module.exports = __webpack_public_path__ + "img/handyman-thin.d55cab61.jpeg";